import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { appConfig } from "../../../config";
import { Job, JobEndpoint, JobsEndpoint } from "../domain/job.model";
import { createAdapterFromEndpointToJob } from "../adapters/jobs.adapter";


const BASE_JOBS_URL = "/jobs";

export const jobsApi = createApi({
    reducerPath: "jobsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: appConfig.API_NODE_URL,
        prepareHeaders: (headers: Headers) => {
            const APP_TOKEN = "app_token";
            const token = localStorage.getItem(APP_TOKEN);

            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }

            return headers;
        },
        credentials: "include",
    }),
    tagTypes: ["Job", "Jobs"],
    endpoints: (builder) => ({
        getJobs: builder.query<Job[], void>({
            query: () => `${BASE_JOBS_URL}`,
            providesTags: ["Jobs"],
            transformResponse: (response: JobsEndpoint): Job[] => {
                return response.Content.Jobs.map((job: JobEndpoint) => createAdapterFromEndpointToJob(job));
            },
        }),
        getExecutionHistory: builder.query<Job[], void>({
            query: () => `${BASE_JOBS_URL}/history`,
            providesTags: ["Jobs"],
            transformResponse: (response: JobsEndpoint): Job[] => {
                return response.Content.Jobs.map((job: JobEndpoint) => createAdapterFromEndpointToJob(job));
            }
        }),
        runJob: builder.mutation<any, any>({
            query: (body) => ({
                url: `${BASE_JOBS_URL}/run`,
                method: "POST",
                body
            })
        }),
        enableJob: builder.mutation<any, any>({
            query: (body) => ({
                url: `${BASE_JOBS_URL}/enable`,
                method: "PUT",
                body
            })
        })
     })
});

export const { 
    useGetJobsQuery,
    useGetExecutionHistoryQuery,
    useRunJobMutation,
    useEnableJobMutation
} = jobsApi;